import React, { useState, useEffect } from 'react';
import { getPageContent, subscribeToPage } from '../firebase/firebase-config';

function Calendar() {
  const [content, setContent] = useState({ session: '2025-26', calendarEvents: [], sliderImages: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await getPageContent('calendar');
        setContent(data);
      } catch (error) { console.error(error); }
      finally { setLoading(false); }
    };
    loadData();
    const unsubscribe = subscribeToPage('calendar', (data) => { if (data) setContent(data); });
    return () => unsubscribe();
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="calendar-page">
      {content.sliderImages && content.sliderImages.length > 0 && (
        <div className="page-banner"><img src={content.sliderImages[0].url} alt="Calendar" /><div className="banner-overlay"><h1>Academic Calendar</h1><p>Session {content.session}</p></div></div>
      )}
      <div className="container">
        <div className="calendar-grid">
          {(content.calendarEvents || []).map((event, idx) => (
            <div key={idx} className="calendar-card">
              <div className="calendar-date">{new Date(event.date).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
              <div className="calendar-event">{event.event}</div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .calendar-page { background: #f8fafc; min-height: 100vh; }
        .page-banner { position: relative; height: 300px; overflow: hidden; }
        .page-banner img { width: 100%; height: 100%; object-fit: cover; }
        .banner-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; text-align: center; }
        .banner-overlay h1 { font-size: 48px; margin-bottom: 10px; }
        .container { max-width: 1200px; margin: 0 auto; padding: 60px 20px; }
        .calendar-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); gap: 20px; }
        .calendar-card { background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1); transition: transform 0.3s; }
        .calendar-card:hover { transform: translateY(-3px); }
        .calendar-date { background: #1a3a6b; color: white; padding: 15px; font-weight: 600; }
        .calendar-event { padding: 20px; color: #334155; }
        .loading { display: flex; justify-content: center; align-items: center; min-height: 60vh; }
        .spinner { width: 50px; height: 50px; border: 4px solid #e2e8f0; border-top-color: #1a3a6b; border-radius: 50%; animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) { .banner-overlay h1 { font-size: 32px; } .calendar-grid { grid-template-columns: 1fr; } }
      `}</style>
    </div>
  );
}
export default Calendar;